import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
function omitTitleTextProps(propName) {
  switch (propName) {
    case "isHeadingMultiline":
    case "type":
      return false;
    default:
      return true;
  }
}
export var StyledTitleText = styled("span", {
  shouldForwardProp: omitTitleTextProps
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex: 1 1 auto;\n    min-width: 0;\n    word-wrap: break-word;\n    ", ";\n\n    ", "\n"])), function (props) {
  return !props.isHeadingMultiline && "\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ";
}, function (_ref) {
  var type = _ref.type;
  switch (type) {
    case "simple":
      return "\n                  margin-top: 3px;\n              ";
  }
});
//# sourceMappingURL=TitleText.js.map